<template>
<div>
    <ol test-id="sav-timeline" class="relative border-l border-gray-300 timeline">
        <li v-for="(block, blockIndex) in blocks" v-show="!block.hide" :test-id="'timeline-item-' + block.key" :key="blockIndex" :class="block.transition" class="mb-10 ml-4" :id="'block-' + block.key">
            <!-- Point timeline -->
            <template v-if="block.type != 'label'">
                <div v-if="blockIndex != blocks.length - 1" class="absolute default-bg-color default-text-inside-color rounded-full p-1 mt-2.5 -left-2" :class="$styleTool.isLight($styleTool.cssConf('defaultBgColor')) ? 'border border-gray-300' : ''">
                    <i class="block fas fa-check" style="font-size: 6px"></i>
                </div>
                <div v-else class="absolute bg-gray-600 rounded-full p-1.5 mt-2 -left-2 border border-white"></div>
            </template>
            <!-- Label -->
            <template v-if="block.type == 'label'">
                <div class="p-5 default-text-color">
                    <div class="text-2xl font-bold">{{block.title}}</div>
                    <div class="mt-1 text-sm font-light">{{block.subtitle}}</div>
                </div>
            </template>
            <!-- Form -->
            <template v-if="block.type == 'form'">
                <div class="form-card animate__animated" :keyname="block.key">
                    <component :is="block.component" @next="callback" @update="clearAllAt" @reset-at="resetAt" :test-id="block.key" />
                </div>
            </template>
        </li>
    </ol>
</div>
</template>

<script>
import eventHub from '@/eventHub'

export default {
    props: {
        start: {
            type: String,
            required: true
        },
        onlyForm: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            blocks: [],
            timerScroll: null
        }
    },

    methods: {
        initForm() {
            // Mange localstorage
            if (localStorage.getItem('form-data')) {
            } else {
                localStorage.setItem('form-data', JSON.stringify({temp: {}}))
            }

            // Add first block
            this.blocks = []
            this.$nextTick(() => {
                // this.addBlockLabel("Identification du produit", "Etape 1/4")
                this.addBlock(this.start)
            })
        },

        addBlock(key) {
            let block = this.$formTool.blockData(key)

            if (block) {
                // Manage component importation
                let path = block.path
                let overwritedPath = path
                if (overwritedPath[0] == '@') {
                    overwritedPath = overwritedPath.substring(1)
                    overwritedPath = overwritedPath.substring(1)
                }

                // Add block
                this.blocks.push({
                    type: 'form',
                    transition: 'animate__fadeIn animate__animated',
                    step: this.blocks.length,
                    key: key,
                    component: require(`./../${overwritedPath}`).default
                })

                // Emit new block
                this.$emit('new-block', block)

                // Scroll
                window.clearTimeout(this.timerScroll)
                this.timerScroll = setTimeout(() => {
                    if (this.blocks.length > 0) {
                        let element = document.getElementById('block-' + this.blocks[this.blocks.length - 1].key)
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth'
                            })
                        }
                    }
                }, 600)
            }
        },

        addBlockLabel(title, subtitle = null) {
            this.blocks.push({
                type: 'label',
                title: title,
                subtitle: subtitle
            })
        },

        clearAllAt(key) {
            let indexCurrentBlock = this.blocks.findIndex(block => block.key == key)
            let exceptionCards = ['client-address']
            for (var index = indexCurrentBlock + 1; index < this.blocks.length; index++) {
                if (!exceptionCards.includes(this.blocks[index].key)) {
                    this.$formTool.removeFormData(this.blocks[index].key);
                }
            }
            this.blocks.splice(indexCurrentBlock + 1, this.blocks.length)
        },

        resetAt(key) {
            let indexCurrentBlock = this.blocks.findIndex(block => block.key == key)
            for (var index = indexCurrentBlock; index < this.blocks.length; index++) {
                this.$formTool.removeFormData(this.blocks[index].key);
            }
            this.blocks.splice(indexCurrentBlock + 1, this.blocks.length)
        },

        callback(info) {
            if (info && info.next) {
                // Add label separation
                // if (info.next.key == 'set-case')
                //     this.addBlockLabel("Validation de votre demande SAV", "Etape 2/3")
                // if (info.current.key == 'set-case')
                //     this.addBlockLabel("Que devez vous faire ?", "Etape 3/3")

                this.addBlock(info.next.key)
            }
        },

        removeLastBlock() {
            this.blocks.pop()
        },

        hideBlockByName(name) {
            const blockIndex = this.blocks.findIndex(block => block.key == name)
            if (blockIndex >= 0) {
                this.blocks[blockIndex].hide = true
                return true
            }
            return false
        },

        goToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },

        giveup() {
            this.$modal.show('confirm-remove-form')
        },

        removeForm() {
            localStorage.removeItem('form-data')
            this.$router.push({name: 'home'})
        }
    },

    mounted() {
        this.initForm()

        eventHub.$on('clear-all-cards', () => {
            if (!this.onlyForm) {
                this.blocks = this.blocks.slice(this.blocks.length - 1)
            }
        })
    }
}
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

.timeline li {
    scroll-margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SavTimelineForm.vue